import { render } from "./BlogWriteComment.vue?vue&type=template&id=c99a354a"
import script from "./BlogWriteComment.vue?vue&type=script&lang=js"
export * from "./BlogWriteComment.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__